<script lang="ts">
    import {onMount} from "svelte";
    import {Cart, getCart} from "../models/cart";
    import CatalogPage from "./products/CatalogPage.svelte";

    export let blocks = [];
    let cart: Cart;
    export let dialog: any = {
        open: false,
        message: ''
    }
    onMount(() => {
        getCart().then((c) => {
            cart = c;
        })
    });
</script>
{#each blocks as block}
    {#if block?.products?.length > 0}
        <section class="py-2 border-bottom">
            <div class="container">
                <CatalogPage title={block.title}
                             {cart}
                             showViewMore={false}
                             data={block.products}/>
            </div>
        </section>
    {/if}
{/each}